import { Alert, Title } from '@mantine/core';
import { useParams } from 'react-router';
import ConnectorsTab from '../components/Connectors/ConnectorsTab';
import Metadata from '../components/Metadata';
import { Page } from '../constants/pageTitles';
import useIsSuperAdmin from '../helpers/useIsSuperAdmin';

const ConnectorsPage = () => {
  const { accountId, domainId } = useParams();
  const isSuperAdmin = useIsSuperAdmin();

  return (
    <>
      <Metadata title={Page.connectors} />
      <Title order={3}>Connectors</Title>

      {isSuperAdmin ? (
        <ConnectorsTab accountId={accountId} domainId={domainId} />
      ) : (
        <Alert color="warning" variant="light" mt="sm">
          Super admins only
        </Alert>
      )}
    </>
  );
};

export default ConnectorsPage;
